export const TEXT_INTENT_MODIFIER_PREFIX = 'ws-indent-';
export const TEXT_INDENT_STEP = 32;
export const MAX_TEXT_INDENT_VALUE = 256;
